import React from "react";
import { StarFilled } from "@ant-design/icons";

const FormLabel = ({ text }) => (
  <div className="flex items-center">
    <span className="font-roboto text-[14px] font-medium leading-5 tracking-[0.005em]">{text}</span>
    <StarFilled className="letter-spacing-1 text-[5px] ml-1 text-red-700" />
  </div>
);

export default FormLabel;
